/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-horizontal-stepper-content{overflow:auto;height:100%}  .mat-horizontal-content-container{height:100%}.buttons-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:2px}"];
export { styles as styles };
